export var selectIsShowModalCreateFolder = function selectIsShowModalCreateFolder(state) {
  return state.favoritesAssignWidget.showModalCreateFolder;
};